module.exports = __webpack_public_path__ + "34bc775d/img/note-edit-icon.acae1669.svg";